var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/Link/index.tsx";
import React from 'react';
import { Text } from '@adc/parallax-component-library';
import styled from 'styled-components';
const BtnWrapper = styled.button`
  border: none;
  background: none;
  padding: 0;
  margin: auto;
  display: flex;
  justify-content: 'center';
  cursor: pointer;
`;
const Link = ({
  children,
  onPress,
  disabled,
  testID,
  IconElement,
  linkTextColor = '$interactive.tertiary.enabled.onColor',
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(BtnWrapper, Object.assign({
    id: testID,
    onClick: onPress,
    disabled: disabled
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 5
    }
  }), IconElement && /*#__PURE__*/React.createElement(IconElement, {
    color: "$interactive.tertiary.enabled.onColor",
    testID: `${testID}-icon`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Text, {
    marginLeft: "$2",
    fontSize: "$bodyBase.strong",
    fontWeight: "$bodyBase.strong",
    color: linkTextColor,
    testID: `${testID}-label`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 7
    }
  }, children));
};
export { Link };